import React, { useMemo } from "react";

import { IUserHomeBase } from "Bands/types";
import { MainTeaser, TeaserProps } from "shared/components";
import { getCountry } from "shared/utils";
import { Icon, IconWithText, MutedDarkText, MutedText, TinyText } from "shared/styles";
import { getHomeBaseTypeIcon } from "Bands/utils";
import { colors } from "shared/styles/constants";
import { Spacer } from "shared/layout";

interface HomeBaseTeaserProps extends IUserHomeBase, TeaserProps {}

export const HomeBaseTeaser: React.FC<HomeBaseTeaserProps> = ({
  name,
  baseType,
  country,
  city,
  ...rest
}) => {
  const mappedCountry = getCountry(country);
  const icon = getHomeBaseTypeIcon(baseType);

  const subTitleComponent = useMemo(
    () => (
      <Spacer size="xxs" spaceDirection="horizontal">
        <Icon as={icon} color={colors.grey4} />
        <MutedDarkText as={TinyText}>{baseType.replaceAll("_", " ")}</MutedDarkText>
      </Spacer>
    ),
    [baseType, icon]
  );

  return (
    <div>
      <MainTeaser
        title={name}
        subTitleComponent={subTitleComponent}
        data-testid="home_base_teaser"
        {...rest}
      >
        <IconWithText>
          {mappedCountry?.flag}
          <TinyText>{mappedCountry?.name}</TinyText>
          <MutedText as={TinyText}>{city}</MutedText>
        </IconWithText>
      </MainTeaser>
    </div>
  );
};
